<template>
    <v-container
        fluid
        class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('menu.ticketVisibility') }}
        </div>

        <v-card>
            <v-card-title class="pb-1">
                <v-row>
                    <v-col>
                        <v-btn
                            class="float-right"
                            color="primary"
                            @click="createTicketVisibility">
                            {{ $t('button.createTicketVisibility') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <ticket-visibility-list-view
                ref="ticketVisibilityListView"
                class="ticketVisibilityListView"
                :items="ticketsVisibility"/>
        </v-card>
    </v-container>
</template>

<script>
import TicketVisibilityListView from '@/views/TicketVisibilityListView'
import { mapState } from 'vuex'

export default {
    name: 'TicketVisibility',
    components: {
        TicketVisibilityListView
    },

    data () {
        return {
        }
    },

    computed: {
        ...mapState('ticketVisibility', ['ticketsVisibility', 'total'])
    },

    mounted () {
        this.fetchTicketsVisibility()
    },

    methods: {
        fetchTicketsVisibility () {
            this.$store.dispatch('ticketVisibility/fetchTicketsVisibility')
        },
        createTicketVisibility () {
            this.$refs.ticketVisibilityListView.openCreateTicketVisibilityPanel()
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
